import request from "./request";
export const getMaterialFetch = () => request("/fileMgt/getFolders", null, "GET");
export const createFolderFetch = (param) => request("/fileMgt/newFolder", param, "GET");
export const saveFolderFetch = (param) => request("/fileMgt/saveFile", param, "POST_JSON");
export const getFilesFetch = (param) => request("/fileMgt/getFiles", param, "GET");
export const getDesignerFetch = (param) => request("/tag/getDesigner", param, "GET");
export const getTagFetch = (param) => request("/tag/getTag", param, "GET");
export const newTagFetch = (param) => request("/tag/newTag", param, "GET");
export const setTagFetch = (param) => request("/fileMgt/setTag", param, "GET");
export const setDesignerFetch = (param) => request("/fileMgt/setDesigner", param, "GET");
export const modNameFetch = (param) => request("/fileMgt/modName", param, "GET");
export const delFilesFetch = (param) => request("/fileMgt/delFiles", param, "GET");
export const getResolutionFetch = (param) => request("/tag/getResolution", param, "GET");
export const copyFilesFetch = (param) => request("/fileMgt/copyFiles", param, "GET");
export const moveFilesFetch = (param) => request("/fileMgt/moveFiles", param, "GET");
export const delFolderFetch = (param) => request("/fileMgt/delFolder", param, "GET");
export const renameFolderFetch = (param) => request("/fileMgt/renameFolder", param, "GET");
export const setDemanderFetch = (param) => request("/fileMgt/setDemander", param, "GET");
export const setCreativeSourceFetch = (param) => request("/fileMgt/setCreativeSource", param, "GET");
// 分配标签
export const distributionTag = (data) => request("/fileMgt/setTag", data, "POST_JSON");
// 分配设计人
export const distributionDesigner = (data) => request("/fileMgt/setDesigner", data, "POST_JSON");
// 分配需求人
export const distributionDemander = (data) => request("/fileMgt/setDemander", data, "POST_JSON");
